import utils from 'util/utils';
import { ReducerRegistry } from '../base/redux';
import {
  LOGOUT,
  SET_AUTHENTICATED,
  SET_LOADING,
  SET_USER_DETAILS,
  SET_USER_PROFILE
} from './actions';
import './subscriber';
import feathers from 'util/client';

const DEFAULT_STATE = {
  user: null,
  loading: false,
  authenticated: false,
  profiles: {}
};

// const filterSubtree = {};

// // start with the default state
// Object.keys(DEFAULT_STATE).forEach((key) => {
//   const key1 = key;
//   filterSubtree[key1] = true;
// });
// PersistenceRegistry.register('features/login', filterSubtree, DEFAULT_STATE);

/**
 * Listen for actions that mutate the billing-counter state.
 */
ReducerRegistry.register('features/login', (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_USER_DETAILS: {
      return {
        ...state,
        loading: false,
        authenticated: true,
        user: action.payload
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        loading: action.payload
      };
    }
    case SET_AUTHENTICATED: {
      return {
        ...state,
        authenticated: action.payload
      };
    }
    case SET_USER_PROFILE: {
      return {
        ...state,
        loading: false,
        profiles: {
          ...state.profiles,
          [action.payload.id]: action.payload.data
        }
      };
    }
    case LOGOUT: {
      feathers.logout();
      utils.clearCache();
      return {
        ...state,
        loading: false,
        authenticated: false,
        user: null
      };
    }
    default:
      return state;
  }
});
